import { Container, Row, Col, Button } from "react-bootstrap";
import { FaFileInvoiceDollar, FaUserPlus } from "react-icons/fa6";
import { Link } from "react-router-dom";
import Base from "./Admin_Base";
import "./AdminDashboard.css";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import { useAuth } from "../Auth/useAuth";

function AdminDashboard() {
  const { admin } = useAuth();
  const fullName = admin?.fullName;
  console.log(admin?.fullName); // or any other property

  return (
    <Base>
      <div className="main_dashboard">
        <Container className="dash_container">
          {fullName == "super_admin" ? (
            <>
              <Row className="align-items-center">
                <Col xs={12} sm={6} lg={4} className="mb-3 dash_col"></Col>
                <Col xs={12} sm={6} lg={4} className="mb-3 dash_col"></Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="mb-3 dash_col d-flex justify-content-end align-items-center"
                >
                  <Link
                    to="/admin/admin_register"
                    className="text-decoration-none"
                  >
                    
                    <Button
                      variant="outline-primary"
                      className="d-flex align-items-center gap-2 shadow-sm"
                    >
                      <FaUserPlus className="fs-6" />
                      <span>Add Admin</span>
                    </Button>
                  </Link>
                   <Link
                    to="/admin/activities"
                    className="text-decoration-none"
                  >
                    
                    <Button
                      variant="outline-primary"
                      className="d-flex align-items-center gap-2 shadow-sm"
                    >
                      <FaUserPlus className="fs-6" />
                      <span>Activities</span>
                    </Button>
                  </Link>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}

          {/* First Row */}
          <Row className="text-center justify-content-center">
            <Col xs={12} sm={6} lg={4} className="mb-3 dash_col">
              <Link to="/admin/area_list" className="dscard">
                {/* <div  */}
                <div className="ds_text">
                  <p className="dscard__description">Area Price Details</p>
                </div>
                <div className="ds_icon">
                  <FaFileInvoiceDollar size={48} />
                </div>
                <button className="view-more-btn">View More</button>
                {/* </div> */}
              </Link>
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-3 dash_col">
              <Link to="/admin/Customerlist" className="dscard">
                <div className="ds_text">
                  <p className="dscard__description">Customers</p>
                </div>
                <div className="ds_icon">
                  {/* <GiHouse size={48} /> */}
                  <GroupsOutlinedIcon style={{ fontSize: 53 }} />
                </div>
                <button className="view-more-btn">View More</button>
              </Link>
            </Col>
          </Row>

          {/* Second Row */}
          <Row className="text-center justify-content-center ds_second_row  ">
            <Col xs={12} sm={6} lg={4} className="mb-3 dash_col">
              <Link to="/admin/customer_property_list" className="dscard">
                <div className="ds_text">
                  <p className="dscard__description">Customer Properties</p>
                </div>
                <div className="ds_icon">
                  <ApartmentOutlinedIcon style={{ fontSize: 53 }} />
                </div>
                <button className="view-more-btn">View More</button>
              </Link>
            </Col>
            <Col xs={12} sm={6} lg={4} className="mb-3 dash_col">
              <Link to="/admin/admin_employeelist" className="dscard">
                <div className="ds_text">
                  <p className="dscard__description">Employees </p>
                </div>
                <div className="ds_icon">
                  <BadgeOutlinedIcon style={{ fontSize: 53 }} />
                </div>
                <button className="view-more-btn">View More</button>
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
    </Base>
  );
}

export default AdminDashboard;
